module.exports = __webpack_public_path__ + "img/do.5d7b9504.svg";